/**
 * activityFormatter — dérivations pures d'une `UIActivity` vers ce qui s'affiche.
 *
 * Pure, sans `@data` / store / service : le design system l'importe directement, comme
 * `dateFormatter`. Le chronomètre d'une activité s'écrit ici, pas dans la ligne qui le rend.
 */
import { type UIActivity } from "../types/activity"

/**
 * Le chronomètre d'une activité — « 12 / 20 min » une fois commencée (écoulé / prévu), « 20 min »
 * tant qu'elle n'a pas été ouverte (décidé par Wajih, 20/10 : le tiret de l'ancien « - / 20 min » se
 * lisait comme un manque), pour l'élève comme pour le parent (« on aligne avec l'élève », Wajih,
 * 20/10). Zéro minute et « pas encore commencée » ne disent toujours pas la même chose : « 0 / 20 min »
 * contre « 20 min ».
 */
export function activityDurationLabel(activity: Pick<UIActivity, "spentMinutes" | "estimatedMinutes">): string {
    const spent = activity.spentMinutes
    return spent == null ? `${activity.estimatedMinutes} min` : `${spent} / ${activity.estimatedMinutes} min`
}
